import React, { useState, useEffect } from 'react';
import { useProfile } from '../../context/contextProfile';
import { useDesign } from '../../context/contextDesign';
import { useThemeMode } from '../../context/contextTheme';
import Subscription from './index';
import apiConfig from '../../api/api-config';
const api_base_url_2 = apiConfig.api_base_url_2;

const SidebarCard = () => {
  const { theme } = useThemeMode();
  const { sidebarExtended } = useProfile();
  
  const [ plan, setPlan ] = useState(sessionStorage.getItem("plan"));

  useEffect(() => {
    setPlan(sessionStorage.getItem("plan"));
  }, []);
  
  return (
    <div className="sidebarExtended mx-auto">
      {plan == 0 ? (
        <div
          className="p-1 z-1 shadow-sm"
          style={{
            bottom: 0,
            margin: '0.26rem',
            borderRadius: '20px',
            border: `1px solid ${theme.border}`,
            backgroundColor: theme.background2,
            // bottom: sidebarExtended ? (!upgradePlan ? 3 : 6) : -400,
            // width: sidebarExtended ? extendedVal - 10 : extendedVal,
            transition: sidebarExtended ?'all 0.7s':'all 0.0s',
          }}>
          <Subscription />
        </div>
      ):(
        <TermsConditions />
      )}
    </div>
  );
};

export default SidebarCard;

const TermsConditions = () => {
  const { theme } = useThemeMode();
  const { toggleUpgradeCard } = useDesign();

  return (
    <div className="text-center py-1">
      <div className='btn btn-secondary mt-2 mb-3'
        onClick={ toggleUpgradeCard }>
        Further Upgrade your plan
      </div>

      <div className="d-flex flex-column mx-auto" 
        style={{ lineHeight: 1.2, width: 200 }}>
        <p>By using our services, you agree to our</p>
        <a href={`${api_base_url_2}/save/terms-and-conditions`} target="_blank" rel="noopener noreferrer"
          style={{ fontSize: '13px', fontWeight: 500, color: theme.textColor }}>
          Terms & Conditions
        </a>
      </div>
    </div>
  )
};